import React, { useEffect, useState, useContext } from 'react';
import { Loading, Pagination } from '@insight/toolkit-react';
import SearchFilter from './SearchFilter/SearchFilter';
import { SearchContext } from '../context/SearchContext';
import { getPageCountOptions } from '../constants';
import SearchControls from './SearchControls/SearchControls';
import { NoResultsFoundWithFacets } from './SearchNotFound/NoResultsFoundWithFacets';
import { scrollToTop } from '../shared/utils';
import { ContentRowForSolAndSerTab } from './ContentTab/ContentRowForSolAndSerTab';

export const SolutionsAndServicesTab = ({
  query,
  showFilters = false,
  setShowFilters,
}) => {
  const {
    contentData,
    tabType,
    contentSearchHandler,
    setContentFilter,
    clearContentFilters,
  } = useContext(SearchContext);
  const items = contentData?.[tabType];

  const {
    facets,
    docs,
    numFound,
    isSearching,
    breadcrumbs,
    originalSpelling,
    correctedSpelling,
    pageNumber: currentPage,
    start,
    rows,
    pages: totalPages
  } = items || {};

  const safeTotalPages = Number.isFinite(Number(totalPages)) && Number(totalPages) > 0
    ? Math.floor(Number(totalPages))
    : 1
  const safeCurrentPageRaw = Number.isFinite(Number(currentPage))
    ? Math.floor(Number(currentPage))
    : 1
  const safeCurrentPage = Math.min(Math.max(safeCurrentPageRaw, 1), safeTotalPages)

  const [contents, setContents] = useState(docs);

  const onFilterChange = (option) => {
    setContentFilter({ group: option.group, val: option.val })
  }

  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }

  const onHandleClearAll = () => {
    clearContentFilters()
  }

  const searchHandler = ({ key, value }) => {
    contentSearchHandler({ key, value })
  }

  const onPageChange = (page) => {
    searchHandler({ key: 'start', value: Number(rows || 50) * (page - 1) });
    scrollToTop();
  }

  useEffect(() => {
    if (items?.docs) {
      setContents(items?.docs);
    }
  }, [items]);

  return (    
      <div className="o-grid solutions-services-wrapper">
        <div className="c-search-page__filters-container o-grid__item u-1/1 u-1/4@desktop">
          <SearchFilter
            outOfStockOnly
            facets={facets}
            showFilters={showFilters}
            breadcrumbs={breadcrumbs}
            setFilter={onFilterChange}
            toggleFilters={toggleFilters}
          />
        </div>
        <div className="c-search-page__products-container o-grid__item u-1/1 u-3/4@desktop">
          <SearchControls
            query={query}
            start={start}
            pageSize={rows}
            showSortOptions={false}
            showPageViewOptions={false}
            totalRecords={numFound}
            currentPage={currentPage}
            originalSpelling={originalSpelling}
            correctedSpelling={correctedSpelling}
            pageCountOptions={getPageCountOptions()}
            setFilter={onFilterChange}
            toggleFilters={toggleFilters}
            clearFilters={onHandleClearAll}
            searchHandler={searchHandler}
          />
          {(!isSearching && !contents?.length) ? (
            <NoResultsFoundWithFacets clearFilters={onHandleClearAll} />
          ) : (
            <SolutionAndServicesTabItem  contents={contents} isSearching={isSearching} onFilterChange={onFilterChange}/>
          )}
        </div>
        <Pagination
          totalPages={safeTotalPages}
          currentPage={safeCurrentPage}
          pageHandler={onPageChange}
        />
      </div>
  )
}

export default SolutionsAndServicesTab;

const SolutionAndServicesTabItem = ({ contents, isSearching, onFilterChange }) => {
  return contents && (
    <>
      {isSearching && (
        <div className="o-grid o-grid--justify-center u-margin-bot-small">
          <div className="o-grid__item o-grid__item--shrink">
            <Loading size={'large'} />
          </div>
        </div>
      )}
      <div className="search-results-wrapper">
        {contents.map((item, id) => {
          const { title, displayDate, pagePath, contentType, description, imageUrl, topics } = item;
          return <ContentRowForSolAndSerTab
            title={title}
            articleDate={displayDate}
            path={pagePath}
            excerpt={description}
            articleType={contentType}
            id={id}
            key={id}
            imageUrl={imageUrl}
            topics={topics}
            onTopicChange={onFilterChange}
          />
        })}
      </div>
    </>
  )
}